module.exports = __webpack_public_path__ + "./img/txt.6fd5ec8c6a135d1762d5bf12d9492971.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/txt.png
// module id = ./src/containers/Briefcase/entry/icons/txt.png
// module chunks = 0